import * as firestore from 'firebase/firestore';
import { DateTime } from 'luxon';
import { UniformRequest } from '../types/UniformRequest';

export default {
  toFirestore(uniformRequest: UniformRequest): firestore.DocumentData {
    return uniformRequest;
  },
  fromFirestore(
    snapshot: firestore.QueryDocumentSnapshot
  ): UniformRequest {
    const data = snapshot.data()!;
    return {
      id: data.id,
      idNumber: data.idNumber,
      name: data.name,
      dateRequested: data.dateRequested,
      dateCompleted: data.dateCompleted,
      type: data.type,
      status: data.status,
      lastUpdate: typeof(data.lastUpdate) === 'string' ? data.lastUpdate : DateTime.fromJSDate((data.lastUpdate as firestore.Timestamp).toDate()).toISO()
    };
  }
};
